import { Navigate } from "react-router-dom";
import { IChildren } from "../interfaces";

export const PrivateRouteAdmin = ({ children }: IChildren): JSX.Element => {
  const isAdmin = localStorage.getItem("isAdmin");

  return <>{isAdmin ? children : <Navigate to={`/admin`} />}</>;
};
